import { PROCESS_TYPES, TEMPLATE_TYPES, TEMPLATES } from "utils/constants";
import Company from "./Company";
import Default from "./Default";
import Demographics from "./Demographics";
import Offer from "./Offer";
import Summary from "./Summary";

const collectiveThemes =
  TEMPLATES[PROCESS_TYPES.B2B].THEMES[TEMPLATE_TYPES.B2B_ACORIS_COLLECTIVE];

const Templates = {
  [collectiveThemes.COMPANY]: Company,
  [collectiveThemes.DEMOGRAPHICS]: Demographics,
  [collectiveThemes.OFFER]: Offer,
  [collectiveThemes.SUMMARY]: Summary,
  default: Default,
};

export default Templates;
